<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>

<div mat-dialog-title class="title">
  <span class="title-text">Order Status Attachments</span>
  <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</div>

<div
  class="msg-container"
  [ngClass]="showMessage ? 'show' : ''"
  [style.background]="backgroundColor"
>
  {{ message }}
</div>

<div
  mat-dialog-content
  class="attachments-container"
  [ngClass]="attachments.length ? 'expanded' : 'collapsed'"
  hrtDndFile
  (fileDropped)="onFileDropped($event)"
>
  <div
    class="attachments-dropzone"
    [ngClass]="attachments.length ? 'drop-small' : 'drop-large'"
  >
    <mat-icon>upload</mat-icon>
    <span>Drag & Drop files here or </span>

    <button (click)="fileInput.click()" class="Button geaui-button-primary">
      Click to upload
    </button>

    <input
      #fileInput
      type="file"
      multiple
      style="display: none"
      (change)="onFileSelected($event)"
    />
  </div>

  <div *ngIf="attachments.length" class="attachments-list">
    <table
      mat-table
      [dataSource]="files"
      class="mat-elevation-z2 custom-mat-table"
    >
      <!-- File Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>File</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <!-- Added On Column -->
      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Added on</th>
        <td mat-cell *matCellDef="let element">
          {{ formatDate(element.created) }}
          <div class="sub-text">by {{ element.userName }}</div>
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="action-buttons">
            <geaui-icon-v2
              file="16px_download"
              [color]="'blue'"
              [colorProp]="'stroke'"
              [clickable]="true"
              (click)="downloadAttachment(element)"
            >
            </geaui-icon-v2>
            <geaui-icon-v2
              file="16px_remove"
              [color]="'blue'"
              [colorProp]="'stroke'"
              [clickable]="true"
              (click)="deleteAttachment(element.id)"
            >
            </geaui-icon-v2>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
